// @copyright  2006 - 2024 West Indies Software Engineering Company Limited. All rights reserved.

export default {
    '$dir': 'ltr',

    'investment-return.page.title': 'Investment Returns',
    'investment-return.page.search_results': 'Search Results',
    'investment-return.page.create.title': 'New Return',
    'investment-return.page.search.title': 'Find Investment Returns',
    'investment-return.page.edit.title': 'Edit Investment Return',
    'investment-return.page.view.title': 'View Investment Return',
    'investment-return.page.title.redo': 'Redo Investment Return',
    'investment-return.page.all': 'All',

    'investment-return.button.cancel': 'Cancel',
    'investment-return.button.select': 'Select',
    'investment-return.button.find': 'Find Investment Returns',
    'investment-return.button.search': 'Apply',
    'investment-return.button.create': 'Add Return',
    'investment-return.button.new': 'New Investment Return',
    'investment-return.button.save': 'Save Changes',
    'investment-return.button.void': 'Void Return',
    'investment-return.button.redo': 'Redo Return',
    'investment-return.button.rollback': 'Rollback Return',
    'investment-return.button.edit': 'Edit',
    'investment-return.button.restore': 'Restore',
    'investment-return.button.reset': 'Reset',

    'investment-return.placeholder.search': 'Search investment returns',

    'investment-return.link.create_first_investment_return': 'Click here to create your first investment return',
    'investment-return.link.investment_returns': 'Return to Investment Returns',
    'investment-return.link.retry': 'Click here to retry',

    'investment-return.checkbox.all': 'Check All',
    'investment-return.checkbox.actions_label': 'with selected',

    'investment-return.label.issue_refund': 'Return Funds',
    'investment-return.label.hold_funds': 'Hold Funds',
    'investment-return.label.investment_name': 'Investment',
    'investment-return.label.investment_return_type_name': 'Investment Return Type',
    'investment-return.label.transaction_date': 'Transaction Date',
    'investment-return.label.currency_name': 'Currency',
    'investment-return.label.currency_amount_in_cents': 'Currency Amount',
    'investment-return.label.rollback_reason': 'Reason for rollback',
    'investment-return.label.bank_general_ledger_account_name': 'Paid To Bank Account',

    'investment-return.sort.field_label': 'Field',
    'investment-return.sort.direction_label': 'Direction',
    'investment-return.sort.direction_ascending': 'Ascending',
    'investment-return.sort.direction_descending': 'Descending',

    'investment-return.modal.title.investment_return_void': 'Void Investment Return',
    'investment-return.modal.title.investment_return_rollback': 'Rollback Investment Return',

    'investment-return.modal.message.investment_return_void': 'Are you sure that you want to void this investment return?',
    'investment-return.modal.message.investment_return_rollback': 'Are you sure that you want to rollback this investment return?',

    'investment-return.success.message.investment_return_created': 'Your investment return has been created',
    'investment-return.success.message.investment_return_updated': 'Your investment return has been updated',
    'investment-return.success.message.investment_return_rolled_back': 'Your investment return has been rolled back',
    'investment-return.success.message.investment_return_voided': 'Your investment return has been voided',

    'investment-return.error.message.investment_return_deleted': 'This investment return was already permanently deleted | These investment returns were already permanently deleted',
    'investment-return.error.message.investment_return_restored': 'This investment return was already restored | These investment returns were already restored',
    'investment-return.error.message.error_loading_page': 'Sorry, there was an error loading investment return.| Sorry, there was an error loading investment returns.',
};
